const color = {
  main: "#aaddff",
  lightBlue: "#F5F5F8",
  lightKhaki: "#F1EFE6",
  lightKhaki02: "#E6E4D8",
  red: "#FE4F60",
  orange: "#FF8A34",
  yellow: "#FFBC25",
  green: "#25C685",
  purple: "#613FC1",
  blue: "#538DFF",
  grey: "#e8e8e8",
  lightGrey: "#F8F8F8",
  darkGrey: "#333",
  black: "#000",
  white: "#fff",
  brandKakao: "#FFEB00",
  brandFacebook: "#4D71C8",
  gray09: "#212529",
  gray08: "#343A40",
  gray07: "#495057",
  gray06: "#868E96",
  gray05: "#ADB5BD",
  gray04: "#ced4da",
  gray03: "#DEE2E6",
  gray02: "#e9ecef",
  gray01: "#F1F3F5",
  gray00: "#F8F9FA",
  blue00: "#edf3ff",
  blue01: "#D6E3FF",
  blue02: "#A3C2FE",
  blue03: "#8eb4fe",
  blue04: "#6b9cfd",
  blue05: "#538DFF",
  blue06: "#3E7CF9",
  blue07: "#3070F1",
  blue08: "#F8F9FA",
  blue09: "#1F58CC",
  red00: "#fff5f5",
  red01: "#ffe3e3",
  red02: "#ffc9c9",
  red03: "#ffa8a8",
  red04: "#ff8787",
  red05: "#ff6b6b",
  red06: "#fa5252",
  red07: "#f03e3e",
  red08: "#e03131",
  red09: "#c92a2a",
  green00: "#E6FCF5",
  green01: "#C3FAE8",
  green02: "#96F2D7",
  green03: "#63E6BE",
  green04: "#38D9A9",
  green05: "#20C997",
  green06: "#12B886",
  green07: "#0CA678",
  green08: "#099268",
  green09: "#087F5B",
  yellow00: "#FFF9DB",
  yellow01: "#FFF3BF",
  yellow02: "#FFEC99",
  yellow03: "#FFE066",
  yellow04: "#FFD43B",
  yellow05: "#FCC419",
  yellow06: "#FAB005",
  yellow07: "#F59F00",
  yellow08: "#F08C00",
  yellow09: "#E67700",
  violet00: "#f3f0ff",
  violet01: "#e5dbff",
  violet02: "#d0bfff",
  violet03: "#b197fc",
  violet04: "#9775fa",
  violet05: "#845ef7",
  violet06: "#7950f2",
  violet07: "#7048e8",
  violet08: "#6741d9",
  violet09: "#5f3dc4",
};

export default color;
